// @flow

import React from 'react';

// Components
import CheckMarkIcon from 'dibs-vg/dist/react/checkmark';
import CloseIcon from 'dibs-vg/dist/react/close';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

// Helpers
import { mutations } from '../utils/constants';
import type { MutationResponses } from '../utils/constants';

import styles from '../styles/errorSuccessModal.scss';

type ErrorSuccessModalProps = {
    description: React$Node,
    isOpen: boolean,
    onClose: () => void,
    title: React$Node,
    type: MutationResponses,
};

const ErrorSuccessModal = ({
    description,
    isOpen,
    onClose,
    title,
    type,
}: ErrorSuccessModalProps) => {
    const IconComponent = type === mutations.responses.ERROR ? CloseIcon : CheckMarkIcon;
    const titleEl = (
        <div>
            <div className={styles.result}>
                <IconComponent className={styles.icon} />
            </div>
            <div data-tn="response-modal-message-title" className={styles.title}>
                {title}
            </div>
        </div>
    );
    return (
        <ModalContainer
            onClose={onClose}
            isOpen={isOpen}
            modalPosition="center"
            dataTn={`share-modal-${type}`}
        >
            <ModalCloseButton onClick={onClose} />
            <BarHeader title={titleEl} />
            <ModalBody>
                <div className={styles.description}>{description}</div>
            </ModalBody>
        </ModalContainer>
    );
};

ErrorSuccessModal.defaultProps = {
    type: mutations.responses.ERROR,
};

export default ErrorSuccessModal;
